import React from "react";
import { Typography, Grid } from "@material-ui/core";
import { DPPermissionGate, DPSpacer } from "Components/DP";
import { CreateRewardForm } from "./CreateRewardForm/CreateRewardForm";
import { useEmployeeProfileQuery } from "Hooks/useEmployeeProfileQueryContext";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { useEmployeeRewards } from "./useEmployeeRewards";
import { EmployeeRewardsTable } from "./EmployeeRewardsTable/EmployeeRewardsTable";
import useStyles from "./styles";

const RewardsTab = () => {
  const classes = useStyles();
  const { userDetails } = useEmployeeProfileQuery();
  const employeeProfileId = userDetails ? userDetails.id : "";
  const canReceiveRewards = !userDetails?.partnerCanceledAt;

  const { rewardsOptions } = usePartnerConfig();
  const canEmployerSendRewards = rewardsOptions?.canSendRewards;

  const {
    employeeRewards,
    loading,
    page,
    perPage,
    onChangePage,
    refetchQueries,
  } = useEmployeeRewards(employeeProfileId);

  return (
    <Grid container direction={"column"} spacing={2}>
      {canEmployerSendRewards && canReceiveRewards && (
        <DPPermissionGate permissionKeys={["canCreateRewards"]}>
          <Grid item>
            <Typography variant="h3">Giving out a reward</Typography>
            <CreateRewardForm
              employeeProfileId={employeeProfileId}
              refetchRewards={refetchQueries}
            />
          </Grid>
          <DPSpacer spacing={8} />
        </DPPermissionGate>
      )}
      <Grid item>
        <Typography variant="h3" className={classes.tableTitle}>
          Reward log
        </Typography>
        <EmployeeRewardsTable
          employeeRewards={employeeRewards}
          loading={loading}
          page={page}
          perPage={perPage}
          onChangePage={onChangePage}
        />
      </Grid>
    </Grid>
  );
};

export default RewardsTab;
